<template>
    <div :style="{backgroundColor:layout?.pageBackground?.color}">
        <!-- Artwork Guidelines Section -->
        <section class="artwork-banner">
            <img 
                v-if="layout?.box1?.image?.preview" 
                :src="layout.box1.image.preview" 
                alt="Artwork Banner"
            />
            <img 
                v-else 
                src="ImageBackgroundSenseofSelf.png" 
                alt="Default Banner"
            />
        </section>

        <section class="artwork">
            <h2 :style="getHeaderStyle()">
                {{ layout?.box2?.header?.text || 'ARTWORK GUIDELINES' }}
            </h2>
            <div class="artwork-container">
                <!-- Accordion Column - Dynamic from Box 3 -->
                <div class="accordion-column">
                    <div 
                        v-for="(item, index) in layout?.box3?.collapsibleItems || []" 
                        :key="index"
                        class="accordion-item"
                    >
                        <div 
                            class="accordion-title" 
                            @click="toggleAccordion(index, 'box3')"
                        >
                            <span>{{ item.header }}</span>
                            <span class="toggle-icon">{{ localExpandedStates.box3[index] ? '−' : '+' }}</span>
                        </div>
                        <div 
                            v-show="localExpandedStates.box3[index]" 
                            class="accordion-content"
                        >
                            <div class="accordion-content-inner" v-html="item.content"></div>
                        </div>
                    </div>
                    
                    <!-- Fallback if no items -->
                    <div v-if="!layout?.box3?.collapsibleItems?.length" class="accordion-item">
                        <div class="accordion-title">
                            <span class="toggle-icon">+</span>
                        </div>
                    </div>
                </div>

                <!-- Image Column - Dynamic from Box 4 -->
                <div class="image-column">
                    <h4 style="margin-bottom: 3rem; font-weight: 500; line-height: 1.2; color: #5e5873;" :style="{
                                fontSize: layout.box4.header.fontSize + 'px',
                                color: layout.box4.header.color,
                                backgroundColor: layout.box4.header.backgroundColor,
                                fontFamily: layout.box4.header.fontFamily,
                                fontWeight: layout.box4.header.bold ? 'bold' : 'normal'
                            }">{{ layout.box4.header.text }}</h4>
                    <img 
                        v-if="layout?.box4?.image?.preview" 
                        :src="layout.box4.image.preview" 
                        alt="Design support" 
                    />
                    <img 
                        v-else 
                        src="ImageBackgroundSenseofSelf.png" 
                        alt="Design support" 
                    />
                    
                    <!-- <div 
                        v-if="layout?.box4?.supportingText?.content"
                        v-html="processDesignLink(layout.box4.supportingText.content)"
                    ></div> -->
                    <!-- new html start -->
                    <span
                        v-if="layout?.box4?.supportingText?.content"
                        class="supporting-text"
                        v-html="processDesignLink(layout.box4.supportingText.content)"
                    ></span>
                    <!-- new html end -->
                </div>
            </div>
        </section>

        <!-- Templates & FAQ Section -->
        <section class="template-faq">
            <div class="template-faq-container">

                <!-- Left: Templates - Dynamic from Box 5 -->
                <div class="templates">
                    <h2>Artwork / Design Templates</h2>
                    <ul>
                        <li 
                            v-for="(guideline, index) in layout?.box5?.guidelines || []" 
                            :key="index"
                            v-if="guideline.name && guideline.fileName"
                        >
                            <span>{{ guideline.name }}</span>
                            <a 
                                href="#" 
                                @click.prevent="downloadPDF(guideline)"
                                download
                            >
                                <img src="https://img.icons8.com/color/48/000000/pdf.png" alt="pdf"> 
                                PDF
                            </a>
                        </li>
                        
                        <!-- Fallback if no guidelines -->
                        <li v-if="!layout?.box5?.guidelines?.length || !hasValidGuidelines()">
                            <span>Guide</span>
                            <a href="#" download>
                                <img src="https://img.icons8.com/color/48/000000/pdf.png" alt="pdf"> 
                                PDF
                            </a>
                        </li>
                    </ul>
                </div>

                <!-- Right: FAQ Accordion - Dynamic from Box 6 -->
                <div class="faq">
                    <h2>{{ layout?.box6?.sectionHeader || 'Frequently Asked Questions' }}</h2>

                    <div 
                        v-for="(faq, index) in layout?.box6?.faqItems || []" 
                        :key="index"
                        class="faq-item"
                    >
                        <div 
                            class="faq-question"
                            @click="toggleAccordion(index, 'box6')"
                        >
                            <span>{{ faq.question }}</span>
                            <span class="faq-icon">{{ localExpandedStates.box6[index] ? '−' : '+' }}</span>
                        </div>
                        <div 
                            v-show="localExpandedStates.box6[index]" 
                            class="faq-answer"
                        >
                            <div class="faq-answer-content" v-html="faq.answer"></div>
                        </div>
                    </div>

                    <!-- Fallback if no FAQs -->
                    <div v-if="!layout?.box6?.faqItems?.length" class="faq-item">
                        <div class="faq-question">
                            <span>What is this product? And what can I use it for?</span>
                            <span class="faq-icon">+</span>
                        </div>
                        <div class="faq-answer">
                            <p><strong>A business card is a card...</strong> <br>
                                This product can be used:<br>
                                • To introduce people to your business<br>
                                • Exchange company/contact information
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "PageLayoutSeven",
    props: {
        layout: {
            type: Object,
            default: () => ({})
        }
    },
    
    data() {
        return {
            // Track expanded states locally for UI interactions
            localExpandedStates: {
                box3: {},
                box6: {}
            }
        }
    },

    mounted() {
        // Initialize expanded states from layout data
        this.initializeExpandedStates();
    },

    watch: {
        layout: {
            handler() {
                this.initializeExpandedStates();
            },
            deep: true
        }
    },

    methods: {
        initializeExpandedStates() {
            // Initialize Box 3 expanded states
            if (this.layout?.box3?.collapsibleItems) {
                this.layout.box3.collapsibleItems.forEach((item, index) => {
                    this.$set(this.localExpandedStates.box3, index, item.expanded || false);
                });
            }

            // Initialize Box 6 expanded states
            if (this.layout?.box6?.faqItems) {
                this.layout.box6.faqItems.forEach((item, index) => {
                    this.$set(this.localExpandedStates.box6, index, item.expanded || false);
                });
            }
        },

        toggleAccordion(index, boxType) {
            if (boxType === 'box3') {
                // Check if clicking on already open item
                const isCurrentlyOpen = this.localExpandedStates.box3[index];
                
                // Close all accordion items first
                Object.keys(this.localExpandedStates.box3).forEach(key => {
                    this.$set(this.localExpandedStates.box3, key, false);
                    if (this.layout?.box3?.collapsibleItems?.[key]) {
                        this.layout.box3.collapsibleItems[key].expanded = false;
                    }
                });
                
                // If it wasn't open before, open it. If it was open, keep it closed (toggle behavior)
                if (!isCurrentlyOpen) {
                    this.$set(this.localExpandedStates.box3, index, true);
                    if (this.layout?.box3?.collapsibleItems?.[index]) {
                        this.layout.box3.collapsibleItems[index].expanded = true;
                    }
                }
            } else if (boxType === 'box6') {
                // Check if clicking on already open item
                const isCurrentlyOpen = this.localExpandedStates.box6[index];
                
                // Close all FAQ items first
                Object.keys(this.localExpandedStates.box6).forEach(key => {
                    this.$set(this.localExpandedStates.box6, key, false);
                    if (this.layout?.box6?.faqItems?.[key]) {
                        this.layout.box6.faqItems[key].expanded = false;
                    }
                });
                
                // If it wasn't open before, open it. If it was open, keep it closed (toggle behavior)
                if (!isCurrentlyOpen) {
                    this.$set(this.localExpandedStates.box6, index, true);
                    if (this.layout?.box6?.faqItems?.[index]) {
                        this.layout.box6.faqItems[index].expanded = true;
                    }
                }
            }
        },

        getHeaderStyle() {
            const header = this.layout?.box2?.header;
            if (!header) return {};

            return {
                fontSize: (header.fontSize || 28) + 'px',
                color: header.color || '#000000',
                backgroundColor: header.backgroundColor || 'transparent',
                fontFamily: header.fontFamily || 'Arial',
                fontWeight: header.bold ? 'bold' : 'normal'
            };
        },

        processDesignLink(content) {
            if (!content || !this.layout?.box4?.designLink?.linkText) return content;
            
            const linkText = this.layout.box4.designLink.linkText;
            const url = this.layout.box4.designLink.url || '/design-quote';
            const color = this.layout.box4.designLink.color || '#007bff';
            
            // Create case-insensitive regex to find the link text
            const regex = new RegExp(`\\b${linkText}\\b`, 'gi');
            return content.replace(regex, `<a href="${url}" style="color: ${color}; text-decoration: none; text-transform: uppercase;">${linkText}</a>`);
        },

        downloadPDF(guideline) {
            if (guideline.fileData && guideline.fileName) {
                // Create download link for base64 data
                const link = document.createElement('a');
                link.href = guideline.fileData;
                link.download = guideline.fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else if (guideline.fileUrl) {
                // If file is stored on server with URL
                window.open(guideline.fileUrl, '_blank');
            } else {
                console.warn('No file data available for download');
            }
        },

        hasValidGuidelines() {
            return this.layout?.box5?.guidelines?.some(g => g.name && g.fileName);
        }
    }
}
</script>

<style scoped>
/* Artwork Banner */
.artwork-banner {
    width: 100%;
    margin-bottom: 30px;
}

.artwork-banner img {
    width: 100%;
    height: auto;
    max-height: 300px;
    object-fit: cover;
}

/* Artwork Section */
.artwork {
    padding: 40px 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.artwork h2 {
    text-align: center;
    margin-bottom: 40px;
    font-size: 28px;
    font-weight: bold;
    color: #333;
}

.artwork-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    align-items: start;
}

/* Accordion Column */
.accordion-column {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.accordion-item {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
}

.accordion-title {
    background: #f8f9fa;
    padding: 15px 20px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    transition: background-color 0.3s ease;
}

.accordion-title:hover {
    background: #e9ecef;
}

.accordion-title span:first-child {
    flex: 1;
    line-height: 1.4;
}

.toggle-icon {
    font-weight: bold;
    font-size: 18px;
    color: #007bff;
    margin-left: 15px;
}

.accordion-content {
    border-top: 1px solid #e0e0e0;
    background: white;
    max-height: none;
    overflow: visible;
}

.accordion-content-inner {
    padding: 20px;
    line-height: 1.6;
    color: #555;
}

.accordion-content-inner p {
    margin: 0 0 15px 0;
    line-height: 1.6;
}

.accordion-content-inner p:last-child {
    margin-bottom: 0;
}

.accordion-content-inner ul,
.accordion-content-inner ol {
    margin: 15px 0;
    padding-left: 25px;
}

.accordion-content-inner ul {
    list-style-type: disc;
}

.accordion-content-inner ol {
    list-style-type: decimal;
}

.accordion-content-inner li {
    margin-bottom: 8px;
    line-height: 1.5;
}

.accordion-content-inner strong,
.accordion-content-inner b {
    font-weight: 600;
    color: #333;
}

.accordion-content-inner em,
.accordion-content-inner i {
    font-style: italic;
}

/* Image Column */
.image-column {
    text-align: center;
    padding: 20px;
}

.image-column img {
    width: 100%;
    max-width: 300px;
    height: auto;
    border-radius: 8px;
    margin-bottom: 20px;
}

.image-column p {
    font-size: 16px;
    line-height: 1.5;
    color: #555;
    margin: 0;
}

.image-column a {
    color: #007bff;
    text-decoration: none;
    font-weight: 500;
}

.image-column a:hover {
    text-decoration: underline;
}

.supporting-text *{
    color:inherit;
}

/* Template & FAQ Section */
.template-faq {
    /* background: #f8f9fa; */
    padding: 60px 20px;
}

.template-faq-container {
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
}

/* Templates */
.templates h2,
.faq h2 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 40px;
    color: #333;
}

.templates ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.templates li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    margin-bottom: 2px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 0;
    transition: all 0.3s ease;
}

.templates li:hover {
    background: #f8f9fa;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.templates li span {
    flex: 1;
    font-weight: 400;
    color: #333;
    font-size: 16px;
}

.templates li a {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #dc3545;
    text-decoration: none;
    font-weight: 500;
    padding: 8px 15px;
    border-radius: 4px;
    transition: all 0.3s ease;
    font-size: 14px;
}

.templates li a:hover {
    background: #f8f9fa;
    color: #c82333;
}

.templates li a img {
    width: 18px;
    height: 18px;
}

/* FAQ */
.faq-item {
    margin-bottom: 2px;
    border: 1px solid #ddd;
    border-radius: 0;
    overflow: hidden;
    background: white;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.faq-question {
    padding: 20px 25px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 400;
    font-size: 16px;
    color: #333;
    transition: background-color 0.3s ease;
    line-height: 1.5;
}

.faq-question:hover {
    background: #f8f9fa;
}

.faq-question span:first-child {
    flex: 1;
    line-height: 1.5;
    padding-right: 20px;
}

.faq-icon {
    font-weight: normal;
    font-size: 20px;
    color: #007bff;
    margin-left: 15px;
    min-width: 20px;
    text-align: center;
}

.faq-answer {
    border-top: 1px solid #e0e0e0;
    background: #fafafa;
    max-height: none;
    overflow: visible;
}

.faq-answer-content {
    padding: 20px;
    line-height: 1.6;
    color: #555;
}

/* Enhanced HTML content styling for FAQ answers */
.faq-answer-content p {
    margin: 0 0 15px 0;
    line-height: 1.6;
}

.faq-answer-content p:last-child {
    margin-bottom: 0;
}

.faq-answer-content ul,
.faq-answer-content ol {
    margin: 15px 0;
    padding-left: 25px;
}

.faq-answer-content ul {
    list-style-type: disc;
}

.faq-answer-content ol {
    list-style-type: decimal;
}

.faq-answer-content li {
    margin-bottom: 8px;
    line-height: 1.5;
}

.faq-answer-content strong,
.faq-answer-content b {
    font-weight: 600;
    color: #333;
}

.faq-answer-content em,
.faq-answer-content i {
    font-style: italic;
}

.faq-answer-content br {
    line-height: 1.8;
}

/* Handle bullet points created with special characters */
.faq-answer-content span {
    display: inline;
}

/* Style for nested lists */
.faq-answer-content ul ul,
.faq-answer-content ol ol,
.faq-answer-content ul ol,
.faq-answer-content ol ul {
    margin: 5px 0;
    padding-left: 20px;
}

/* Style for long content */
.faq-answer-content {
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: normal;
}

/* Ensure content doesn't get cut off */
.faq-answer {
    transition: all 0.3s ease;
}

/* Fix for TinyMCE generated content */
.faq-answer-content [style*="background-color"] {
    background-color: transparent !important;
}

.faq-answer-content [style*="font-family"] {
    font-family: inherit !important;
}

/* Responsive Design */
@media (max-width: 768px) {
    .artwork-container,
    .template-faq-container {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    .artwork {
        padding: 30px 15px;
    }

    .artwork h2 {
        font-size: 24px;
    }

    .templates h2,
    .faq h2 {
        font-size: 20px;
    }

    .accordion-title,
    .faq-question {
        padding: 12px 15px;
        font-size: 14px;
    }

    .accordion-content,
    .faq-answer {
        padding: 15px;
    }

    .templates li {
        flex-direction: column;
        gap: 10px;
        text-align: center;
    }

    .templates li span {
        text-align: center;
    }
}

/* Loading States */
.loading-placeholder {
    background: #f0f0f0;
    border-radius: 4px;
    animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

/* Error States */
.error-message {
    color: #dc3545;
    text-align: center;
    padding: 20px;
    font-style: italic;
}

/* Accessibility */
.accordion-title:focus,
.faq-question:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
}

.templates li a:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
}

/* Print Styles */
@media print {
    .template-faq {
        background: white !important;
    }
    
    .accordion-title,
    .faq-question {
        cursor: default;
    }
}
</style>